//
//
//
//
//
//
//

  import JsBridge from 'JsBridge'
  export default {
    name: 'app',
    mounted () {
      console.log('version: 1.0.2')
      console.log('enter GameCenter.vue')
      JsBridge.initialize()
      JsBridge.registerHandler('receiveMessage', this.onReceiveMessage)
      JsBridge.registerHandler('isGameListView', this.isGameListView)
    },

    methods: {
      onReceiveMessage (msg) {
        console.log('onReceiveMessage ' + msg)
        if (!msg) return
        let obj = JSON.parse(msg)
        if (!obj) return
        if (obj.type === 'REQ_QUIT') JsBridge.callHandler('finishWeb', null, null)
      },
      isGameListView (data, responseCallback) {
        if (!responseCallback) {
          console.log('isGameListView  null')
        }
        responseCallback('1')
        return true
      }
    }
}



// WEBPACK FOOTER //
// ./src/App.vue